<template>
  <LoadingAnimationFlower :size="size" />
</template>

<script lang="ts">
import LoadingAnimationFlower from './LoadingAnimationFlower.vue';

export default {
  components: {
    LoadingAnimationFlower,
  },
  props: {
    size: {
      type: String,
      default: 'lg',
      validator: (value) => typeof value === 'string' && ['sm', 'md', 'lg'].includes(value),
    },
  },
};
</script>
